import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const iso = (d) => d.toISOString().slice(0, 10);
const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d; };

export const PRESETS = [
  { key: "7d", label: "7 days", range: () => ({ start: iso(daysAgo(6)), end: iso(new Date()) }) },
  { key: "30d", label: "30 days", range: () => ({ start: iso(daysAgo(29)), end: iso(new Date()) }) },
  { key: "month", label: "This month", range: () => { const n = new Date(); return { start: iso(new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1))), end: iso(n) }; } },
  { key: "90d", label: "90 days", range: () => ({ start: iso(daysAgo(89)), end: iso(new Date()) }) },
];

export const AnalyticsRange = ({ preset, onChange }) => {
  const [custom, setCustom] = useState({ start: "", end: "" });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="analytics-range">
      {PRESETS.map((p) => (
        <Button key={p.key} size="sm" variant={preset === p.key ? "default" : "outline"}
          className={`rounded-full ${preset === p.key ? "bg-[#1D3557] hover:bg-[#162a47]" : ""}`}
          onClick={() => onChange(p.key, p.range())} data-testid={`analytics-preset-${p.key}`}>{p.label}</Button>
      ))}
      <div className="flex items-center gap-1.5 ml-1">
        <Input type="date" value={custom.start} onChange={(e) => setCustom({ ...custom, start: e.target.value })} className="h-9 w-[150px] text-xs" data-testid="analytics-custom-start" />
        <span className="text-slate-400 text-xs">to</span>
        <Input type="date" value={custom.end} onChange={(e) => setCustom({ ...custom, end: e.target.value })} className="h-9 w-[150px] text-xs" data-testid="analytics-custom-end" />
        <Button size="sm" variant={preset === "custom" ? "default" : "outline"} className="rounded-full"
          disabled={!custom.start || !custom.end || custom.start > custom.end}
          onClick={() => onChange("custom", custom)} data-testid="analytics-custom-apply">Apply</Button>
      </div>
    </div>
  );
};

export const ChangeBadge = ({ value, testId }) => {
  if (value === null || value === undefined) return <span className="text-[11px] text-slate-400" data-testid={testId}>No prior data</span>;
  const up = value > 0, flat = value === 0;
  const Icon = flat ? Minus : up ? TrendingUp : TrendingDown;
  const cls = flat ? "text-slate-500 bg-slate-100" : up ? "text-emerald-700 bg-emerald-50" : "text-red-600 bg-red-50";
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${cls}`} data-testid={testId}>
      <Icon size={12} /> {up ? "+" : ""}{value}% vs prev
    </span>
  );
};
